





















































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";

interface Data {
    store: MetRiportStore;
    loading: boolean;
}

interface Methods {
    editExport(id: number): void;
    removeExport(id: number): void;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        IconButton
    },

    async beforeMount() {
        this.loading = true;
        await store.loadExportStatuses();
        this.loading = false;
    },

    data() {
        return {
            store,
            loading: false,
        };
    },

    
    methods: {
        editExport(id: number): void {
            this.store.metRiportExportHead.id = id;
            this.$router.push(`/met-riport/export/edit/${id}`);
        },
        removeExport(id: number): void {
            store.removeMetRiportExport(id).then(r => eventBus.$emit('refreshMetRiportExports'));
        }
    },

    computed: {
        url() {
            return `met-riport/${Number(this.$route.params["metRiportId"]) || 0}/exports/search`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    filterable: false,
                    sortable: false,
                },
                {
                    field: "id",
                    title: "Azonosító",
                    type: ColumnType.Right
                },
                {
                    field: "beginDate",
                    title: "Kezdődátum",
                    type: ColumnType.Date
                },
                {
                    field: "endDate",
                    title: "Végdátum",
                    type: ColumnType.Date,
                    format: "{dddd}"
                },
                {
                    field: "status",
                    title: "Státusz",
                    cell: "status",
                    multiselect: true,
                    multiselectField: "selectedExportStatuses",
                    multiselectOptions: store.exportStatuses.map((x) => ({
                        text: x.name,
                        value: x.id,
                    }))
                }
            ];
        },
    }
});
